import React, { useState } from 'react';

const demos = [
  {
    id: '_V4OrRpiNrA',
    title: 'Infrastructure Deployment',
    description: 'Watch the fully automated infrastructure provisioning process — from API call to live assistant with automated validation tests.',
    takeaway: 'Your agent is live with a phone number in under 5 minutes',
    icon: 'fa-server',
  },
  {
    id: 'jBodDe0-3cw',
    title: 'Assistant Creation & RAG',
    description: 'Create a new assistant from template with FAQ links that are ingested and indexed for real-time RAG-powered responses.',
    takeaway: 'Knowledge is ingested and searchable — no prompt engineering needed',
    icon: 'fa-user-plus',
  },
  {
    id: '4B0xDZ6gERA',
    title: 'Automated Testing',
    description: 'Fully automated end-to-end testing with different user scenarios and checkpoint validation to verify assistant behavior before going live.',
    takeaway: 'Catch issues before your customers do — not after',
    icon: 'fa-flask',
  },
  {
    id: 'G-n2uqhJpzg',
    title: 'FAQ Optimizer',
    description: 'AI-powered content gap analysis evaluates assistant performance, identifies missed questions, and generates TODO items to eliminate hallucination risk.',
    takeaway: 'Every missed question becomes an action item, not a hallucination',
    icon: 'fa-magic',
  },
];

const DemoVideos = () => {
  const [activeDemo, setActiveDemo] = useState(0);
  const current = demos[activeDemo];

  return (
    <div id="demos" className="px-8 py-20 bg-neutral-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
            See How Your AI Is Tested Before It Talks to Customers
          </h2>
          <p className="!text-stone-300 text-lg font-medium font-['Inter'] max-w-2xl mx-auto">
            From provisioning to validation — watch every step of the deploy-and-verify workflow.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/3 flex flex-col gap-3">
            {demos.map((demo, index) => (
              <button
                key={demo.id}
                onClick={() => setActiveDemo(index)}
                className={`text-left p-4 rounded-lg transition-all ${
                  activeDemo === index
                    ? 'bg-[#055EFD] text-white'
                    : 'bg-neutral-800 text-stone-300 hover:bg-neutral-700'
                }`}
              >
                <div className="flex items-center gap-3 mb-2">
                  <i className={`fa ${demo.icon} text-sm ${activeDemo === index ? 'text-white' : 'text-[#0AF1FE]'}`}></i>
                  <span className="font-bold font-['Montserrat'] text-sm">{demo.title}</span>
                </div>
                <p className={`text-xs font-['Inter'] leading-relaxed ${activeDemo === index ? 'text-white/80' : 'text-stone-400'}`}>
                  {demo.description}
                </p>
              </button>
            ))}
          </div>

          <div className="lg:w-2/3">
            <div className="rounded-lg overflow-hidden bg-black" style={{ aspectRatio: '16/9' }}>
              {current.id.startsWith('PLACEHOLDER') ? (
                <div className="w-full h-full flex flex-col items-center justify-center bg-neutral-800 text-stone-400">
                  <i className={`fa ${current.icon} text-4xl mb-4 text-[#0AF1FE]`}></i>
                  <p className="text-sm font-['Inter'] font-medium">{current.title} — Demo Coming Soon</p>
                </div>
              ) : (
                <iframe
                  key={current.id}
                  src={`https://www.youtube.com/embed/${current.id}`}
                  title={current.title}
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  className="w-full h-full border-0"
                />
              )}
            </div>
            {/* Takeaway */}
            <div className="mt-3 flex items-center gap-2 bg-neutral-800 border border-neutral-700 rounded-lg px-4 py-3">
              <i className="fa fa-arrow-right text-[#0AF1FE] text-xs"></i>
              <p className="!text-stone-300 text-sm font-medium font-['Inter']">{current.takeaway}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoVideos;
